module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-03eedc3bab59e8bbc46628400306113d.webp";